export const faqs = [
  {
    q: "忍界同人志是官方组织吗？",
    a: "不是。忍界同人志是火影忍者爱好者自发建设的同人内容聚合与导航站点，我们整理与收录来自同人圈的作品、合集与社区资源，与任何官方机构无关，所有作品版权归原作者与版权方所有。",
  },
  {
    q: "如何找到某类特定的同人作品？",
    a: "进入「作品库」页面，可以使用顶部的主题分类进行筛选，例如长篇连载、热血战斗、清水治愈、穿越重生等；也可以直接在搜索框中输入作品名、角色或标签关键词快速定位，支持即时检索。",
  },
  {
    q: "作品库多久更新一次？",
    a: "我们每天都会跟进社区的最新动态，热门作品与合集会在数小时至一天内入库更新。每部作品的「最近更新」时间会如实标注，方便你判断追更进度，追更不迷路。",
  },
  {
    q: "我可以在这里发布自己的同人作品吗？",
    a: "忍界同人志目前以导航与推荐为主，暂不开放直接投稿。如果你希望自己的作品被收录，可以通过页面底部的联系方式向我们提供作品信息，经审核后将加入对应的合集目录。",
  },
  {
    q: "站内推荐的同人是否经过筛选？",
    a: "是的。我们对推荐内容有基本的标准：尊重原著、内容健康、无盗用与侵权风险，并综合社区的读者口碑与热度进行排序。热门推荐旨在帮助你快速发现优质内容，同时保证阅读体验。",
  },
  {
    q: "收藏和评论功能在哪里使用？",
    a: "在单部作品的详情页，你可以看到收藏与热度数据，用于判断作品受欢迎程度。社区讨论、收藏夹与评论互动功能正在筹备中，后续版本将逐步开放，敬请期待。",
  },
  {
    q: "发现侵权或不当内容该如何反馈？",
    a: "如果你发现站内收录的内容存在盗用、侵权或违反社区规范的情况，欢迎通过页脚的邮箱联系我们。我们会第一时间核实并处理，同时保护原作者与读者的权益。",
  },
];